module.exports = __webpack_public_path__ + "static/media/retrait-au-magasin.a2297d39.svg";